import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Layout } from "antd";

import SiteHeader from "./SiteHeader";
import ContentWrapper from "./ContentWrapper";
import Sidebar from "../Menus/Sidebar";
import EventBreadcrumb from "../Menus/Breadcrumb";

export default function PageLayout({ children, title = "Dashboard" }) {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  const SIDEBAR_EXPANDED = 240;
  const SIDEBAR_COLLAPSED = 64;

  useEffect(() => {
    window.scrollTo(0, 0);
    const mq = window.matchMedia("(max-width: 991px)");

    const handle = (e) => {
      if (e.matches) {
        setIsMobile(true);
        setCollapsed(true); // collapse for mobile
      } else {
        setIsMobile(false);
        setCollapsed(false); // EXPAND when switching to desktop
        setDrawerOpen(false); // make sure drawer is closed
      }
    };

    handle(mq); // initial
    mq.addEventListener("change", handle);
    return () => mq.removeEventListener("change", handle);
  }, []);

  const sidebarWidth = isMobile
    ? 0
    : collapsed
    ? SIDEBAR_COLLAPSED
    : SIDEBAR_EXPANDED;

  const toggleMobileMenu = () => setDrawerOpen((v) => !v);
  const isEventDetailsPage = location.pathname.includes("event-details");

  return (
    <Layout>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        isMobile={isMobile}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        expandedWidth={SIDEBAR_EXPANDED}
        collapsedWidth={SIDEBAR_COLLAPSED}
      />

      <SiteHeader
        title={title}
        sidebarWidth={sidebarWidth}
        isMobile={isMobile}
        onToggleMobileMenu={toggleMobileMenu}
      />

      {isEventDetailsPage && (
        <div
          className="breadcrumb"
          style={{
            width: "calc(100% - " + sidebarWidth + "px)",
            marginLeft: sidebarWidth,
          }}
        >
          <EventBreadcrumb />
        </div>
      )}

      <ContentWrapper
        sidebarWidth={sidebarWidth}
        hasBreadcrumb={isEventDetailsPage}
      >
        {children}
      </ContentWrapper>
    </Layout>
  );
}
